var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaperPlane = function SvgPaperPlane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141,
    height: 149,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paper-plane_svg__a)",
    d: "m53.665 148.336 42.544-37.877 19.284 22.044c1.588 1.815 4.589.697 4.589-1.711v-40.28c0-.823-.391-1.597-1.053-2.087L39.19 29.192c-.337-.25-.024-.77.357-.593L139 74.849a2.63 2.63 0 0 0 2.142.032l47.277-20.266c2.276-.975 2.04-4.262-.353-4.905L3.301.093C1.279-.45-.532 1.475.144 3.448l49.302 143.788c.605 1.765 2.823 2.343 4.22 1.1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paper-plane_svg__a",
    x1: 0,
    x2: 144.704,
    y1: 0,
    y2: 184.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004EFF"
  })))));
};
export default SvgPaperPlane;